import React from "react";
import CmsManager from "./CmsManager";

function ClientsPageEditor() {
  return (
    <CmsManager
      title="Our Clients Page"
      resource="clients-page"
      singleton
      fields={[
        {
          name: "title",
          label: "Page Heading",
          fullWidth: false,
          defaultValue: "Our Clients",
        },
        {
          name: "description",
          label: "Intro Description",
          type: "textarea",
          rows: 5,
        },
        {
          name: "content",
          label: "Full Description",
          type: "richtext",
        },
        {
          name: "slug",
          label: "URL Slug",
          fullWidth: false,
          defaultValue: "our-clients",
        },
        { name: "metaTitle", label: "Title Tag", fullWidth: false },
        {
          name: "metaDescription",
          label: "Meta Description",
          type: "textarea",
          rows: 3,
        },
        {
          name: "metaKeywords",
          label: "Meta Keywords",
          type: "keywords",
          rows: 2,
        },
      ]}
    />
  );
}

export default ClientsPageEditor;
